export default __webpack_public_path__ + "static/media/list-selected.5f9d2688.svg";